export const apiRoot = window.apiRoot || "http://api.mmjp5000.com/";
